import { render, staticRenderFns } from "./Lgx331139085617856512.vue?vue&type=template&id=96e44c70&scoped=true&"
import script from "./Lgx331139085617856512.vue?vue&type=script&lang=js&"
export * from "./Lgx331139085617856512.vue?vue&type=script&lang=js&"
import style0 from "./Lgx331139085617856512.vue?vue&type=style&index=0&id=96e44c70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e44c70",
  null
  
)

export default component.exports